import "./App.css";
import { Helmet } from "react-helmet";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Dashboard from "./pages/dashboard/Dashboard";
import Customer from "./pages/customer/Customer";
import Login from "./components/auth/Login";
import Agent from "./pages/agent/Agent";
import ProtectedRoute from "./utils/ProtectedRoutes";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PigmyCollections from "./pages/collections/PigmyCollections";
import LoanCollections from "./pages/collections/LoanCollections";
import GroupLoan from "./pages/groupLoan/GroupLoan";
import CustomerReport from "./pages/report/individualReport/customerReport";
import PigmyReport from "./pages/report/individualReport/pigmyReport";
import PigmyCollectionReport from "./pages/report/individualReport/pigmyCollectionReport";
import LoanReport from "./pages/report/individualReport/loanReport";
import LoanCollectionReport from "./pages/report/individualReport/loanCollectionReport";
import weeklyLoanCollectionReport from "./pages/report/individualReport/weeklyLoanCollectionReport";
import GroupLoanReport from "./pages/report/groupReport/groupLoanReport";
import GroupLoanCollectionReport from "./pages/report/groupReport/groupLoanCollectionReport";
import WeeklyGroupLoanCollectionReport from "./pages/report/groupReport/weeklyGroupCollectionReport";
import Enquiry from "./pages/customer/enquiry/enquiry";
import Permissions from "./pages/permissions/permissions";
import CreatePigmyRequest from "./pages/pigmy/createPigmyRequest";
import WithdrawPigmyRequest from "./pages/pigmy/withdrawRequests";
import GroupPigmy from "./pages/groupPigmy/GroupPigmy";
import GroupPigmyReport from "./pages/report/groupReport/groupPigmyReport";
import GroupPigmyCollectionReport from "./pages/report/groupReport/groupPigmyCollectionReport";
import GroupCustomer from "./pages/groupLoan/GroupCustomer";
import Accounts from "./pages/accounts/accounts";
import Settings from "./pages/settings/settings";

function App() {
  return (
    <BrowserRouter>
      <Helmet defaultTitle="HP-Finance" />
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard"
          element={<ProtectedRoute element={Dashboard} />}
        />
        <Route
          path="/customer/*"
          element={<ProtectedRoute element={Customer} />}
        />
        <Route path="/agent/*" element={<ProtectedRoute element={Agent} />} />
        <Route
          path="/pigmy-collections/*"
          element={<ProtectedRoute element={PigmyCollections} />}
        />
        <Route
          path="/loan-collections/*"
          element={<ProtectedRoute element={LoanCollections} />}
        />
        <Route
          path="/group/*"
          element={<ProtectedRoute element={GroupLoan} />}
        />
        <Route
          path="/group-customer/*"
          element={<ProtectedRoute element={GroupCustomer} />}
        />
        <Route
          path="/group-pigmy/*"
          element={<ProtectedRoute element={GroupPigmy} />}
        />
        <Route
          path="/customer-report"
          element={<ProtectedRoute element={CustomerReport} />}
        />
        <Route
          path="/pigmy-report"
          element={<ProtectedRoute element={PigmyReport} />}
        />

        <Route
          path="/pigmy-collection-report"
          element={<ProtectedRoute element={PigmyCollectionReport} />}
        />
        <Route
          path="/loan-report"
          element={<ProtectedRoute element={LoanReport} />}
        />
        <Route
          path="/loan-collection-report"
          element={<ProtectedRoute element={LoanCollectionReport} />}
        />
        <Route
          path="/weekly-loan-collection-report"
          element={<ProtectedRoute element={weeklyLoanCollectionReport} />}
        />
        <Route
          path="/group-pigmy-report"
          element={<ProtectedRoute element={GroupPigmyReport} />}
        />
        <Route
          path="/group-pigmy-collection-report"
          element={<ProtectedRoute element={GroupPigmyCollectionReport} />}
        />
        <Route
          path="/group-loan-report"
          element={<ProtectedRoute element={GroupLoanReport} />}
        />
        <Route
          path="/group-loan-collection-report"
          element={<ProtectedRoute element={GroupLoanCollectionReport} />}
        />
        <Route
          path="/weekly-group-loan-collection-report"
          element={<ProtectedRoute element={WeeklyGroupLoanCollectionReport} />}
        />
        <Route
          path="/enquires"
          element={<ProtectedRoute element={Enquiry} />}
        />

        <Route
          path="/pigmy-requests"
          element={<ProtectedRoute element={CreatePigmyRequest} />}
        />
        <Route
          path="/pigmy-withdraw-requests"
          element={<ProtectedRoute element={WithdrawPigmyRequest} />}
        />
        <Route
          path="/permissions/*"
          element={<ProtectedRoute element={Permissions} />}
        />
        <Route
          path="/accounts"
          element={<ProtectedRoute element={Accounts} />}
        />
        <Route
          path="/settings"
          element={<ProtectedRoute element={Settings} />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
